module.exports = __webpack_public_path__ + "media/promo/promo/images/arrow-back-d848e59b48139a4fdcba95b7ba8f4450.svg";